/**
 * Paliers de montage par produit — photos complètes du plat à chaque étape.
 * Images : src/assets/images/optimized/product-tiers/
 */
export const PRODUCT_TIER_RECIPES = {
  'dowhile-burger': [
    { label: 'Étape 1 — La base' },
    { label: 'Étape 2 — Le fromage' },
    { label: 'Étape 3 — Les légumes' },
    { label: 'Étape 4 — La sauce' },
    { label: 'Étape 5 — Complet' },
  ],
  'chicken-burger': [
    { label: 'Étape 1 — La base' },
    { label: 'Étape 2 — Le coleslaw' },
    { label: 'Étape 3 — Les cornichons' },
    { label: 'Étape 4 — La sauce' },
    { label: 'Étape 5 — Complet' },
  ],
  'tacos-xxl': [
    { label: 'Étape 1 — La tortilla' },
    { label: 'Étape 2 — La viande' },
    { label: 'Étape 3 — Les frites' },
    { label: 'Étape 4 — La sauce' },
    { label: 'Étape 5 — Complet' },
  ],
  'tacos-poulet': [
    { label: 'Étape 1 — La tortilla' },
    { label: 'Étape 2 — Le poulet' },
    { label: 'Étape 3 — Les légumes' },
    { label: 'Étape 4 — La sauce' },
    { label: 'Étape 5 — Complet' },
  ],
  'crepe-nutella': [
    { label: 'Étape 1 — La crêpe' },
    { label: 'Étape 2 — Le Nutella' },
    { label: 'Étape 3 — Les fruits' },
    { label: 'Étape 4 — Complet' },
  ],
  'crepe-salee': [
    { label: 'Étape 1 — La crêpe' },
    { label: 'Étape 2 — Jambon & fromage' },
    { label: 'Étape 3 — L\'œuf' },
    { label: 'Étape 4 — Complet' },
  ],
};

export function getProductTierRecipe(productId) {
  return PRODUCT_TIER_RECIPES[productId] || null;
}

export function supportsProductTiers(product) {
  return Boolean(PRODUCT_TIER_RECIPES[product.id]);
}
